                  $(document).on("click",".data_cart_beg #vehicle3",function() {
                        var value =  $(this).attr('attr');
                        if (value == 'false'){
                            $(this).attr('attr',true);
                        }else{
                            $(this).attr('attr',false);
                        }
                    });


             $(document).on("click", ".btn_check", function() {
                var value = $('#vehicle3').attr('attr');
                var id = $('cart-items.cart__items.cart_data_store .cart__item:first-child').attr('var-id');
                var quty = $('cart-items.cart__items.cart_data_store .cart__item:first-child .cart__item__content .cart__quantity input').attr('value');

                if (value == 'true') {
                    var property = $('#vehicle3').attr('value');
                    console.log("property:", property);

                    $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: {
                            id: id,
                            quantity: quty,
                            properties: { "gift_wrap": property }
                        },
                        dataType: 'json',
                        success: function(response) {
                            console.log('Request successful:', response);
                            window.location.href = '/checkout';
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            console.error('Request failed:', textStatus, errorThrown);
                            console.log('Response Text:', jqXHR.responseText);
                        }
                    });


                }
            });

$(document).ready(function(){
  if(window.innerWidth <= 525){
    // let div = document.createElement('div');
    // div.classList.add('slider__arrows');
    // div.style.height = '50px';
    // div.innerHTML = window.theme.sliderArrows.prev + '' + window.theme.sliderArrows.next;
    // document.querySelector('.tab-content-1 .grid-outer grid-slider').append(div)
  }
});